import { Accessor } from '@deck.gl/core';
import { PathLayer } from '@deck.gl/layers';
import isHiddable from '../modules/isHiddableModule.js';

export class HidablePathLayer<TData, TProps = object> extends PathLayer<TData, TProps & { getIsHidden: Accessor<TData, 0 | 1> }> {
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.addInstanced({
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, isHiddable]
        };
    }
}
